export const OFFER_GENERATED_DESCRIPTION_ROOM_RANGES_CONTENT = {
    AREA_FROM_PREFIX: "od ",
    AREA_TO_PREFIX: " do ",
    PRICE_FROM_PREFIX: "w cenie od ",
    ROOMS_AREA_LABEL: "-pokojowe o powierzchni ",
    getCountLabel: (count: number, offerTypeLabel: string) => ` (${count} ${offerTypeLabel})`
} as const;
export const OFFER_GENERATED_DESCRIPTION_ROOM_RANGES_CONTENT = {
    AREA_FROM_PREFIX: "od ",
    AREA_TO_PREFIX: " do ",
    PRICE_FROM_PREFIX: "w cenie od ",
    ROOMS_AREA_LABEL: "-pokojowe o powierzchni ",
    getCountLabel: (count: number, offerTypeLabel: string) => ` (${count} ${offerTypeLabel})`
} as const;
